import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../common/Header";
import $ from "jquery";
import useAuth from "../../hooks/useAuth";
import { GETREQUEST, POSTREQUEST } from "../helpers/ServiceRequest";

function EditUser() {
  const [email, setEmail] = useState("");
  const [emailErr, setEmailErr] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [firstNameErr, setFirstNameErr] = useState(false);
  const [lastName, setLastName] = useState("");
  const [lastNameErr, setLastNameErr] = useState(false);
  const [userName, setUserName] = useState("");
  const [userNameErr, setUserNameErr] = useState(false);
  const [role, setRole] = useState("");
  const [roleErr, setRoleErr] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordErr, setPasswordErr] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPasswordErr, setConfirmPasswordErr] = useState(false);
  const [current, setCurrent] = useState();
  const [errorMessage, setErrorMessage] = useState("");
  const [disabled, setDisabled] = useState(false);
  const [showConfirmPassword, setShowCPassword] = useState(false);
  const [confirmPasswordError, setCPwError] = useState(false);
  const [passwordHash, setPasswordHash] = useState("");
  const { user } = useAuth();
  useEffect(() => {
    var headerHeight = $("header").outerHeight();
    var mainHeight = $(window).height() - headerHeight;
    $("main").height(mainHeight);
    $("main").css("margin-top", headerHeight + "px");
  });
  let navigate = useNavigate();
  const { id } = useParams();
  useEffect(() => {
    const fetchData = async () => {
      let URL = process.env.REACT_APP_API_URL + "/get-user/" + id;
      let response = await GETREQUEST(URL, user.jwtToken);
      if (response?.data) {
        setEmail(response.data.Email);
        setFirstName(response.data.FirstName);
        setLastName(response.data.LastName);
        setUserName(response.data.UserName);
        setRole(response.data.Role);
        setPasswordHash(response.data.Password);
        setCurrent(String(response.data.Current));
      }
    }
    fetchData();
  }, []);

  const editUser = async (e) => {
    e.preventDefault();
    setDisabled(true);
    let updateUserURL = process.env.REACT_APP_API_URL + "/update-user";
    if (
      email == "" &&
      firstName == "" &&
      lastName == "" &&
      userName == "" &&
      role == ""
    ) {
      setEmailErr(true);
      setFirstNameErr(true);
      setLastNameErr(true);
      setUserNameErr(true);
      setRoleErr(true);
      return false;
    }

    let payload = {
      Email: email,
      FirstName: firstName,
      LastName: lastName,
      UserName: userName,
      Role: role,
      Password: password,
      ConfirmPassword: confirmPassword,
      Current: parseInt(current),
      UserID: id,
    };
    if (
      email != "" &&
      firstName != "" &&
      lastName != "" &&
      userName != "" &&
      role != ""
    ) {
      let response = await POSTREQUEST(updateUserURL, payload, user.jwtToken);
      if (response?.data) {
        setDisabled(false);
        navigate("/users");
      } else {
        setErrorMessage(response?.error?.message);
      }
    } else if (email == "") {
      setEmailErr(true);
      return false;
    } else if (firstName == "") {
      setFirstNameErr(true);
      return false;
    } else if (lastName == "") {
      setLastNameErr(true);
      return false;
    } else if (userName == "") {
      setUserNameErr(true);
      return false;
    } else if (role == "") {
      setRoleErr(true);
      return false;
    }
  };

  const checkPassword = async(event) => {
    let checkPasswordURL =
      process.env.REACT_APP_API_URL + "/check-password-new";
    let payloadPassword = {
      Password: password,
    };
    let response = await POSTREQUEST(checkPasswordURL, payloadPassword, user.jwtToken);
    if(response?.data){
      if (password != "" && password === passwordHash) {
        setShowCPassword(false);
        setDisabled(false);
      } else if (password != "" && response.data.message === 0) {
        setShowCPassword(true);
      } else {
        setShowCPassword(false);
        setDisabled(false);
      }
    }
  };
  return (
    <React.Fragment>
      <Header />
      <main className="bg-lite-grey overflow-auto">
        <section className="px-4 pt-3 pb-4">
          <div className="table-elements">
            <nav style={{ ariaLabel: "breadcrumb" }}>
              <ol className="breadcrumb">
                <li className="breadcrumb-item fs-15">
                  <Link
                    to="/users"
                    className="text-decoration-none text-primary"
                  >
                    Users
                  </Link>
                </li>
                <li
                  className="breadcrumb-item fs-15 active"
                  aria-current="page"
                >
                  Edit User
                </li>
              </ol>
            </nav>
          </div>
          <div className="row justify-content-center">
            <div className="width-xxl-35 width-xl-44 width-lg-60 width-md-80">
              <div className="card p-4">
                <div className="card-header bg-white border-bottom-0">
                  <h1 className="title-semibold fs-24 mb-1">Edit User</h1>
                </div>
                <form onSubmit={editUser}>
                  <div className="card-body">
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Email
                      </label>
                      <div className="col">
                        <input
                          type="email"
                          className={
                            "form-control input-md " +
                            (emailErr ? " is-invalid" : "")
                          }
                          placeholder="Enter Email"
                          onChange={(e) => {
                            setEmailErr(false);
                            setEmail(e.target.value);
                          }}
                          defaultValue={email}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                        User Name
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className={
                            "form-control input-md " +
                            (userNameErr ? " is-invalid" : "")
                          }
                          placeholder="Enter User Name"
                          onChange={(e) => {
                            setUserNameErr(false);
                            setUserName(e.target.value);
                          }}
                          defaultValue={userName}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                        First Name
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className={
                            "form-control input-md " +
                            (firstNameErr ? " is-invalid" : "")
                          }
                          placeholder="Enter First Name"
                          onChange={(e) => {
                            setFirstNameErr(false);
                            setFirstName(e.target.value);
                          }}
                          defaultValue={firstName}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Last Name
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className={
                            "form-control input-md " +
                            (lastNameErr ? " is-invalid" : "")
                          }
                          placeholder="Enter Last Name"
                          onChange={(e) => {
                            setLastNameErr(false);
                            setLastName(e.target.value);
                          }}
                          defaultValue={lastName}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Password
                      </label>
                      <div className="col">
                        <input
                          type="password"
                          className={
                            "form-control input-md " +
                            (passwordErr ? " is-invalid" : "")
                          }
                          placeholder="Enter Password"
                          onChange={(e) => {
                            setPasswordErr(false);
                            setPassword(e.target.value);
                          }}
                          defaultValue={password}
                          onBlur={(e) => {
                            checkPassword(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div
                      className="cmb-15 row g-3"
                      style={
                        showConfirmPassword
                          ? { display: "flex" }
                          : { display: "none" }
                      }
                    >
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Confirm Password
                      </label>
                      <div className="col">
                        <input
                          type="password"
                          className={
                            "form-control input-md " +
                            (confirmPasswordErr ? " is-invalid" : "")
                          }
                          placeholder="Enter Confirm Password"
                          onChange={(e) => {
                            setPasswordErr(false);
                            setConfirmPassword(e.target.value);
                            if (password != e.target.value) {
                              setConfirmPasswordErr(true);
                              setDisabled(true);
                            } else {
                              setConfirmPasswordErr(false);
                              setDisabled(false);
                            }
                          }}
                          required={showConfirmPassword && "required"}
                        />
                      </div>
                      {confirmPasswordError && (
                        <div className="text-danger text-center">
                          {" "}
                          Confirm password is not matched{" "}
                        </div>
                      )}
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Role
                      </label>
                      <div className="col">
                        <select
                          className={
                            "form-select input-md " +
                            (roleErr ? "is-invalid" : "")
                          }
                          aria-label="Default select example"
                          onChange={(e) => {
                            setRoleErr(false);
                            setRole(e.target.value);
                          }}
                          value={role}
                        >
                          <option value="">Select Role</option>
                          <option value="Admin">Admin</option>
                        </select>
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Status
                      </label>
                      <div className="col">
                        <select
                          className="form-select input-md "
                          aria-label="Default select example"
                          onChange={(e) => {
                            setCurrent(e.target.value);
                          }}
                          value={current}
                        >
                          <option value={1}>Active</option>
                          <option value={0}>Inactive</option>
                        </select>
                      </div>
                    </div>
                    {errorMessage && (
                      <div className="text-danger text-center">
                        {" "}
                        {errorMessage}{" "}
                      </div>
                    )}
                  </div>
                  <div className="card-footer bg-white d-flex p-3 border-top-0">
                    <div className="d-grid w-100">
                      <button
                        type="submit"
                        className="btn btn-secondary btn-md text-white d-flex align-items-center justify-content-center px-4 fw-medium rounded-3 mx-1"
                      >
                        Edit User
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
}

export default EditUser;
